import React from "react";
import ".//Update.css";

export default function CustomerComparisonTable({ lookUpResponse, handleUpdateWynshopLoyaltyId }) {
    return (
        <div className="table-wrapper">
            <table className="table table-hover table-bordered custom-table">
                <thead className="thead-dark">
                <tr>
                    <th scope="col">Source</th>
                    <th scope="col">Customer ID</th>
                    <th scope="col">Email</th>
                    <th scope="col">Phone</th>
                    <th scope="col">Loyalty ID</th>
                </tr>
                </thead>
                <tbody>
                <tr key="wynshop">
                    <th scope="row">Wynshop</th>
                    <td>{lookUpResponse?.meta?.wynshopCustomer?.id || "-"}</td>
                    <td>{lookUpResponse?.meta?.wynshopCustomer?.email || "-"}</td>
                    <td>{lookUpResponse?.meta?.wynshopCustomer?.phoneNo || "-"}</td>
                    <td className="loyalty-cell">
                        {lookUpResponse?.meta?.wynshopCustomer?.loyaltyId || "-"}
                        {lookUpResponse?.meta?.wynshopCustomer?.id &&
                            lookUpResponse?.meta?.wynshopCustomer?.loyaltyId?.length > 11 && (
                                <button
                                    id="sub_btn"
                                    type="button"
                                    className="fix-btn"
                                    onClick={() =>
                                        handleUpdateWynshopLoyaltyId(lookUpResponse?.meta?.wynshopCustomer?.id)
                                    }
                                >
                                    Fix
                                </button>
                            )}
                    </td>
                </tr>

                <tr key="inmar">
                    <th scope="row">Inmar</th>
                    <td>{lookUpResponse?.meta?.inmarCustomer?.id || "-"}</td>
                    <td>{lookUpResponse?.meta?.inmarCustomer?.email || "-"}</td>
                    <td>{lookUpResponse?.meta?.inmarCustomer?.phoneNo || "-"}</td>
                    <td>{lookUpResponse?.meta?.inmarCustomer?.loyaltyId || "-"}</td>
                </tr>

                {lookUpResponse?.data?.map((customer) => (
                    <tr key={customer?.id}>
                        <th scope="row">Cosmos</th>
                        <td>{customer?.id || "-"}</td>
                        <td>{customer?.email || "-"}</td>
                        <td>{customer?.phoneNo || "-"}</td>
                        <td>{customer?.loyaltyId || "-"}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}